import { render, staticRenderFns } from "./global-header.vue?vue&type=template&id=49439c7d&shadow"
import script from "./global-header.vue?vue&type=script&lang=js&shadow"
export * from "./global-header.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./global-header.vue?vue&type=style&index=0&id=49439c7d&prod&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports